import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store/index'
import Cookies from 'js-cookie'

Vue.use(VueRouter)

let routes = [
  {
    path: '/',
    redirect: '/sites'
  },
  {
    name: 'dashboard',
    path: '/sites/:tagId?',
    meta: { layout: 'app-layout' },
    component: require('../components/Dashboard/Dashboard').default
  },
  {
    name: 'login',
    path: '/login',
    meta: { layout: 'simple-layout' },
    component: require('../views/Login').default
  },
  {
    name: 'register',
    path: '/register',
    meta: { layout: 'simple-layout' },
    component: require('../views/Register').default
  },
  {
    name: 'verify',
    path: '/verify',
    meta: { layout: 'simple-layout' },
    component: require('../views/Verify').default
  },
  {
    name: 'forget',
    path: '/forget',
    meta: { layout: 'simple-layout' },
    component: require('../views/Forget').default
  },
  {
    name: 'resetpassword',
    path: '/resetpassword',
    meta: { layout: 'simple-layout' },
    component: require('../views/Resetpassword').default
  },
  {
    path: '/updates',
    name: 'updates',
    meta: { layout: 'app-layout' },
    component: require('../components/Updates/Updates').default
  },
  {
    path: '/extensions',
    name: 'extensions',
    meta: { layout: 'app-layout' },
    component: require('../components/Extensions/Extensions').default
  },
  {
    path: '/activity',
    name: 'activity',
    meta: { layout: 'app-layout' },
    component: require('../components/Activity/Activity').default
  },
  {
    name: 'siteDestroy',
    path: '/site/:id/destroy',
    meta: { layout: 'app-layout' },
    component: require('../components/Sites/SiteDestroy').default
  },
  {
    name: 'sitesDestroy',
    path: '/sites/destroy',
    meta: { layout: 'app-layout' },
    component: require('../components/Sites/SitesDestroy').default
  },
  {
    name: 'toolbox',
    path: '/toolbox',
    meta: { layout: 'app-layout' },
    component: require('../components/Toolbox/TheToolbox').default
  },
  {
    name: 'userProfile',
    path: '/profile',
    meta: {
      layout: 'app-layout',
      tab: 0
    },
    component: require('../components/User/TheUser').default
  },
  {
    name: 'userInvoices',
    path: '/invoices',
    meta: {
      layout: 'app-layout',
      tab: 3
    },
    component: require('../components/User/TheUser').default
  },
  {
    name: 'userPayment',
    path: '/payment',
    meta: {
      layout: 'app-layout',
      tab: 2
    },
    component: require('../components/User/TheUser').default
  },
  {
    name: 'userList',
    path: '/userlist',
    meta: { layout: 'app-layout' },
    component: require('../components/Users/Users').default
  },
  {
    name: 'userDestroy',
    path: '/user/:id/destroy',
    meta: { layout: 'app-layout' },
    component: require('../components/Users/UserDestroy').default
  },
  {
    name: 'invoiceList',
    path: '/invoicelist',
    meta: { layout: 'app-layout' },
    component: require('../components/Invoices/Invoices').default
  },
  {
    name: 'forecast',
    path: '/forecast',
    meta: { layout: 'app-layout' },
    component: require('../components/Invoices/Forecast').default
  },
  {
    name: 'addCard',
    path: '/addCard',
    meta: { layout: 'app-layout' },
    component: require('../components/User/PaymentAddCard').default
  },
  {
    name: 'addSepa',
    path: '/addSepa',
    meta: { layout: 'app-layout' },
    component: require('../components/User/PaymentAddSepa').default
  },
  {
    name: 'support',
    path: '/support',
    meta: {
      layout: 'app-layout',
      tab: 5
    },
    component: require('../components/User/TheUser').default
  },
  {
    name: 'dpaInfo',
    path: '/dpa',
    meta: {
      layout: 'app-layout',
      tab: 4
    },
    component: require('../components/User/TheUser').default
  },
  {
    name: 'settings',
    path: '/settings',
    meta: {
      layout: 'app-layout',
      tab: 1
    },
    component: require('../components/User/TheUser').default
  },
  {
    name: 'addSite',
    path: '/addSite/:config',
    meta: { layout: 'app-layout' },
    component: require('../components/Sites/AddSite').default
  }
]

const router = new VueRouter({
  routes,
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  store.commit('setLayout', to.meta.layout)
  const tabs = ['userProfile', 'userInvoices', 'userPayment', 'support', 'dpaInfo', 'settings']
  if (!tabs.includes(from.name) || !tabs.includes(to.name)) {
    store.commit('common/resetLoading')
    store.commit('common/startLoading')
  }

  if (to.meta.hasOwnProperty('tab')) {
    store.commit('setTab', to.meta.tab)
  }

  const token = Cookies.get('bm-token')

  const onPublicPage = ((to.fullPath === '/login' ||
      to.fullPath === '/register' ||
      to.fullPath === '/forget' ||
      to.fullPath.substr(0, 14) === '/resetpassword' ||
      to.fullPath.substr(0, 8) === '/addSite' ||
      to.fullPath.substr(0, 7) === '/verify')
  )

  if (!token) {
    store.commit('common/resetLoading')
    if (onPublicPage) {
      next()
    } else {
      next({ path: '/login' })
    }
  } else {
    if (onPublicPage && to.fullPath.substr(0, 8) !== '/addSite') {
      next({ path: '/sites' })
    }

    store.dispatch('user/getUser').then(
      (response) => {
        if (!(to.fullPath === '/payment' || to.fullPath === '/addCard' || to.fullPath === '/addSepa') && response && response.data && !response.data.service_enabled) {
          next({ path: '/payment' })
        } else {
          next()
        }
      })
  }
})

export default router
